/* eslint-disable no-unused-vars*/
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row, Skeleton, Typography, Card } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { postCreateAnnounceOwner, getAnnounceOwnerById } from 'api/announceOwner';
import { getCookie } from 'helper/cookie';
import Swal from 'sweetalert2';
import { get } from 'lodash';
import { Editor } from '@tinymce/tinymce-react';
import { VITE_REACT_TINY_API_KEY } from 'src/private/config';
import DOMPurify from 'dompurify';

export const formatDate = 'YYYY-MM-DDTHH:mm:ssZ';
const { Title } = Typography;

interface propType {
  id: number;
}

const CreateAnnounceOwner = (props: propType) => {
  const { id } = props;
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const token = getCookie('access_tokenltl');
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataTextEditor, setDataTextEditor] = useState('');

  const handleEditorChange = (content: any, editor: any) => {
    setDataTextEditor(content);
  };

  const fetchAnnounceOwnerById = useCallback(async () => {
    setIsLoading(true);
    try {
      const responseData = await getAnnounceOwnerById({ token });
      if (responseData?.status === 200) {
        const { data } = responseData;
        setData(data?.data);
        form.setFieldsValue({
          announce_owner_detail: DOMPurify.sanitize(data?.data?.announce_owner_detail),
          owner_id: data?.data?.owner_id,
          group_user_id: data?.data?.group_user_id,
        });
        setDataTextEditor(DOMPurify.sanitize(data?.data?.announce_owner_detail));
      } else {
        setData('');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useMemo(() => {
    if (token) fetchAnnounceOwnerById();
  }, [token]);

  const handleSubmit = async () => {
    const params = {
      announce_owner_detail: DOMPurify.sanitize(dataTextEditor),
    };
    const createData = await postCreateAnnounceOwner({ token, params });
    if (createData.status === 200) {
      Swal.fire({ icon: 'success', title: 'บันทึกข้อมูลสำเร็จ', showConfirmButton: false, timer: 3000 });
      await fetchAnnounceOwnerById();
    } else {
      Swal.fire({ icon: 'error', title: createData?.data?.message || 'บันทึกข้อมูลไม่สำเร็จ', showConfirmButton: false, timer: 4000 });
    }
  };

  return isLoading ? (
    <Skeleton active />
  ) : (
    <Card style={{ padding: 24, borderRadius: 16, boxShadow: '0 8px 24px rgba(0,0,0,0.08)', background: '#ffffff' }} bodyStyle={{ padding: 0 }}>
      <Form layout="vertical" autoComplete="off" onFinish={handleSubmit} form={form} initialValues={{ announce_owner_detail: '' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
          🗞️ สร้างประกาศสำหรับ แจ้งให้สมาชิกคุณทราบ
        </Title>
        <Editor
          id="text-editor"
          apiKey={VITE_REACT_TINY_API_KEY}
          init={{
            height: 500,
            menubar: false,
            plugins: ['advlist', 'code', 'autolink', 'lists', 'link', 'image', 'preview', 'visualblocks', 'table'],
            toolbar:
              'undo redo | fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | preview code',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          }}
          onEditorChange={handleEditorChange}
          value={dataTextEditor}
        />
        <Row gutter={16} style={{ marginTop: 24 }}>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit" size="large" icon={<SaveOutlined />}>
              {id ? 'อัปเดตประกาศ' : 'บันทึกประกาศ'}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default CreateAnnounceOwner;
